import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';

@Component({
	selector: 'rx-intuitive-bridge-diagram-footer',
	templateUrl: './rx-intuitive-bridge-diagram-footer.component.html',
	styleUrls: ['./rx-intuitive-bridge-diagram-footer.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, TlkButtonComponent]
})
export class RxIntuitiveBridgeDiagramFooterComponent {
	@Input() hasUnsavedChanges = false;
	@Input() isReadOnly = false;

	@Output() save = new EventEmitter<void>();
	@Output() revert = new EventEmitter<void>();
	@Output() closed = new EventEmitter<void>();

	onSaveBridge(): void {
		this.save.emit();
	}

	onRevertChanges(): void {
		this.revert.emit();
	}

	onClose(): void {
		this.closed.emit();
	}
}
